<template>
  <el-container
    :class="['mod-layout', 'page-' + routeName]"
  >
    <el-header class="layout-header">
      <a 
        class="logo"
        @click="goHome"
      >
        趣智营销商业开放平台
      </a>
      <div 
        v-if="routeName !== 'login'" 
        class="menus-box"
      >
        <el-menu
          v-if="menus && menus.length"
          :default-active="activeMenu" 
          class="el-menu-demo"
          active-text-color="#1890FF"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item 
            v-for="item in menus" 
            :key="item.key" 
            :index="item.key"
          >
            {{ item.name }}
          </el-menu-item>
        </el-menu>
      </div>
      <template v-if="routeName !== 'login'">
        <span class="btn-link-box">
          <a 
            class="btn-link" 
            @click="goDoc"
          >
            开发文档
          </a>
        </span>
      </template>
      <template v-if="devShow && company">
        <i class="icon-separator-vertical" />
        <span class="btn-link-box register">
          <a 
            class="btn-link" 
            @click="goRegister"
          >
            注册成为开发者
          </a>
        </span>
      </template>
      <template v-if="routeName !== 'login'">
        <i class="icon-separator-vertical" />
        <el-dropdown
          v-if="company" 
          @command="handleCommand"
        >
          <span class="profile">{{ company }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item 
              v-for="item in dropItems" 
              :key="item.key"
              :command="item.key"
            >
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <span
          v-else
          class="btn-link-box"
        >
          <a
            class="btn-link"
            @click="goLogin"
          >
            登录
          </a>
        </span>
      </template>
    </el-header>
    <el-main class="content-main">
      <div
        :class="[routeName, 'content-view']"
      >
        <router-view v-if="!agreementShow" />
      </div>
    </el-main>
    <el-dialog
      :visible.sync="agreementShow"
      width="70%"
      center
      :close-on-click-modal="false"
      :show-close="false"
      class="agreement-dialog"
    >
      <h1 slot="title">“AIclk”广告推广API用户协议</h1>
      <pre 
        class="agreement-box" 
        :style="{height: agreementHeight + 'px'}"
      >
为了更好地为您提供服务，请您仔细阅读《AIclk推广API使用协议》（以下简称“本协议”）。 
在您开始使用“AIclk推广API”相关服务之前，请您务必认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。 除非您完全接受本协议的全部内容，否则您无权下载、安装、注册、登录、使用（以下统称“使用”）“AIclk”软件，或者通过任何方式使用“AIclk推广API”服务，或者获得“AIclk推广API”提供的任何服务 （本协议中统称“使用”）。若您点击“同意”按钮，则视为您已充分理解本协议并承诺作为本协议的一方当事人接受协议的约束。 
一、定义
1.API合作方权限是AIclk授予给签约参与AIclk推广API项目的软件开发用户的密钥。使用合作方权限和AIclk推广API的前提是接受本协议的所有条款。作为AIclk推广的一项功能，所有通过AIclk推广API对账户进行的操作都在本协议条款的约束之下。
2.使用：AIclk推广API的“使用”包括下列含义(A)使用AIclk推广API说明文档中记述的脚本语言(i)通过AIclk推广API对AIclk服务器进行存取，(ii)通过AIclk推广API客户端将信息传给AIclk广告后台账户，(iii) 响应AIclk推广API调用而从AIclk接收数据；抑或(B)管理AIclk推广客户端。
3.账户所有人：指AIclk广告后台账户所有人或其授权使用并管理其账户的第三方。
4.AIclk推广API客户端：是指（i）通过AIclk推广API与AIclk服务器进行通讯或存取的软件系统（AIclk推广API主客户端），（ii）可以与AIclk推广API主客户端交换AIclk推广数据的软件。
5.AIclk推广API数据：是指AIclk推广API数据报告和AIclk推广API输入数据。
6.AIclk推广API数据报告：是指通过AIclk推广API接收的从AIclk发送的数据或内容。
7.AIclk推广API输入数据：是指通过AIclk推广API向AIclk发送的数据、指令或内容。
8.AIclk推广API推广设置数据：是指那些发送到AIclk推广API服务器后可以改变推广现有或未来状态的AIclk推广API输入数据。
9.AIclk推广API说明文档：是指AIclk提供的一切关于AIclk推广API规范与协议或安装与使用的信息和文档。
10.AIclk推广API最终用户客户端：是指拥有人自身产品或服务推广管理专用（不是代理或批发商为其他组织购买推广）。AIclk推广API最终用户客户端不得转让，许可使用或出售。
二、授权使用
1.使用许可您根据本协议约定的条款使用AIclk推广API合作方权限代码。您只获得使用唯一的通用API权限代码。
2.您不得利用通用API权限代码使用非经最终客户授权的AIclk推广API客户端。
3.AIclk可以任意终止或暂停您的AIclk推广API，或变更AIclk推广API的任何说明、协议或读取方法，而无需为此承担任何法律责任。您需要自己承担数据备份以及API无法连接时对账户的管理。
4.AIclk推广API数据报告
a)您不得出售、转卖、配发或其他披露转让AIclk推广API数据报告，除非对象是授权您使用最终用户客户端API的账户所有人。 
b)您需要为通过合作方权限代码做的所有API保管和操作等行为负责，并承担因其保管和操作等行为所引发的一切法律后果。 
c)您需要保证AIclk推广数据保存在安全环境。至少在与AIclk通讯时应使用AIclk API服务器支持的加密协议。 
d)除非AIclk产品或服务的功能有公开许可，您不得使用AIclk推广API以外的其他自动手段（例如网页数据截取或机器人程序）读取、查询或其他收集方式采集AIclk推广或AIclk自有以及AIclk联盟上有AIclk推广的网页。 
5.您应知晓AIclk有权监控任何AIclk推广API的操作以确保质量并改进产品与服务。您不得屏蔽或干扰AIclk的监控。AIclk保留使用技术手段排除干扰的权利。
6.您使用AIclk推广API或其说明文档进行最终用户客户端的管理必须遵守本协议中规定各条款。您确认，AIclk推广API仅为信息技术服务提供者，您应为利用AIclk推广API及AIclk推广API账户进行的所有行为负责。若AIclk推广API账号或AIclk推广API账号下行为出现纠纷时（包括但不限于实施违法违规行为等），由您自行承担全部责任。
7.AIclk推广API客户端不得允许读取使用任何通过截取AIclk网页获得的数据。AIclk推广API客户端不得允许除账户所有人或所有人授权代理以外任何一方获取账户名、密码、AIclk推广API数据或者其他账户相关数据。
三、免责
1.您确认AIclk推广API是一个处于不断更新完善的产品及服务，本协议不能保证AIclk推广API合作方权限代码的持续使用的权利。您同意AIclk的免责并不会以任何理由追究AIclk推广API的责任。
2.为保证您对AIclk推广API合作方权限代码的使用安全和遵守本协议各条款，AIclk推广API有权对您及您管理客户端API使用情况进行审查。
3.您应保证在AIclk广告后台账户所有人的授权范围内读取、使用账户内的数据及信息，不得超越授权范围外进行操作。否则，AIclk推广API有权立即停止您的权限，并保留追究您法律责任的一切权利。 
四、知识产权
1.双方单独享有的商标权、著作权或者其他知识产权，均仍归各方单独享有，并不会因为双方签订或者履行本协议而转归对方享有，或者转归双方共同享有。
2.任何一方均应尊重相对方、第三方的知识产权，如有任何第三方就一方侵犯其知识产权等合法权益原因向另一方提起诉讼、主张索赔的，责任方应当独立处理相关纠纷，赔偿另一方的直接经济损失，并使另一方完全免责。
五、服务的变更、中断和终止
1.您理解并同意，AIclk推广API为了服务整体运营的需要，有权在公告通知后修改、中断、中止或终止相关服务，而无须向您负责或承担任何赔偿责任。
2.本协议的提前终止不应影响双方于本协议提前终止日之前根据本协议已产生的权利义务。
六、不可抗力
1.您理解并同意，在使用AIclk推广API的过程中可能会遇到以下情况使服务发生中断。出现下述情况时，AIclk推广API应及时与相关单位配合进行修复，但对由此给您造成的损失AIclk推广API将予以免责。
a)不可抗力，包括但不限于自然灾害、政府行为、政策颁布调整、法律法规颁布调整、罢工、动乱；
b)运营商过错，包括但不限于电信部门技术调整、电信/电力线路被他人破坏、电信/电力部门对电信网络/电力资源进行安装、改造、维护；
c)网络安全事故，如计算机病毒、木马或其他恶意程序、黑客攻击的破坏；
d)您操作不当或甲方的电脑软件、系统、硬件和通信线路出现故障；
e)其他非AIclk推广API过错、AIclk推广API无法控制或合理预见的情形。
2.因不可抗力、运营商过错、网络安全事故或其他超出当事人可合理掌控范围的事件，造成本合同迟延履行或任何一方违约，双方均无需承担违约责任。但是，受影响一方应尽可能及时通知另一方。如前述事件妨碍本合同履行达30日以上的，任一方可提前15日书面通知对方终止本协议。因本条款终止本协议的，任何一方均无须承担违约责任。
3.您理解并同意，AIclk推广API按照现有技术和条件将尽最大努力确保服务连贯性和安全性。如AIclk推广API存在瑕疵，且该瑕疵为现有技术和条件无法避免，AIclk推广API无须承担违约责任。
七、违约责任
1.针对您违反本协议或其他服务条款规定的行为，AIclk推广API有权独立判断并视情况采取预先警示、限制使用直至停止服务等措施。AIclk推广API有权公告处理结果，且有权根据实际情况决定是否恢复使用。对涉嫌违反法律法规、涉嫌违法犯罪的行为将保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。
2.因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致AIclk推广API及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿公司及其关联公司、控制公司因此遭受的全部损失。
3.因您违反本协议或其他服务条款规定，造成AIclk推广API向任何第三方承担责任的，AIclk推广API在承担所述责任后有权向用户足额追偿，由此产生的合理费用包括但不限于，律师费、公证费、鉴定费、差旅费、诉讼费等亦由用户承担。
八、其他
1.您必须遵守中华人民共和国法律法规以及AIclk系统的相关规定。凡因本协议所生纠纷，双方应提请上海市浦东新区人民法院审理。
2.您不得以任何手段干扰AIclk推广API的正常运作。
3.您需要迅速方便地为任何正在用您AIclk推广API合作方权限管理账户的最终客户办理退出或注销等服务，解除合作方权限代码对最终客户账户的关联并将账户控制权完全移交给账户所有人。

      </pre>
      <span 
        slot="footer" 
        class="dialog-footer"
      >
        <el-button 
          type="primary" 
          @click="submitAgreement"
        >
          确 定
        </el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { getDevInfo, getUserInfo, doLogout, signAgreement } from '@/service';
import Cookie from 'js-cookie'

export default {
  data() {
    let pathname = location.pathname;
    let activeMenu = pathname.split('/')[1] || 'home';
    return {
      menus: [],
      activeMenu: activeMenu.toLowerCase(),
      company: '',
      dropItems: [
        {
          key: 'logout',
          name: '退出登录',
        },
      ],
      agreementShow: false,
      agreementHeight: 500,
      devShow: false,
    };
  },
  computed: {
    routeName() {
      let routeName = this.$route.name.toLowerCase();
      this.activeMenu = routeName;
      routeName !== 'login' && this.getInfo();
      return routeName;
    },
    routerShow() {
      const noCheck = ['home', 'login'];
      return noCheck.indexOf(this.routeName) > -1;
    },
  },
  created() {
    this.agreementHeight = document.body.offsetHeight - 350;
  },
  methods: {
    async getInfo() {
      let devRes = await getDevInfo();
      if (devRes.code === 200 && !devRes.data.is_old_user) {
        this.devShow = true;
        this.company = devRes.data.company || '';
        if (!['home', 'register'].includes(this.routeName)) {
          this.goHome();
        }
        return;
      }
      this.devShow = false;
      let res = await getUserInfo();
      if (res.code !== 200) {
        if (this.routeName !== 'home') {
          this.goHome();
        }
        return;
      }
      this.company = res.data.company || '';
      if (!this.company) {
        this.doLogout();
        this.showLoginMessage();
        if (this.routeName !== 'home') {
          this.goHome();
        }
      } else if (this.company && res.data.agreement) {
        this.menus = [
          {
            key: 'home',
            name: '首页',
          },
          {
            key: 'appmanage',
            name: '应用管理',
          },
          {
            key: 'accountaccess',
            name: '账号授权',
          },
        ];
      } else if (!res.data.agreement) {
        this.agreementShow = true;
      }
    },
    async doLogout(callback) {
      let res = await doLogout();
      if (res.code === 200) {
        Cookie.remove('MK_USER_ID', {path: '/', domain: '.aiclk.com'});
        Cookie.remove('NAGATO_PROOF', {path: '/', domain: '.aiclk.com'});
        this.menus = [];
        this.devShow = false;
        callback && callback();
      }
    },
    async submitAgreement() {
      const { message } = await signAgreement();
      this.$message.success(message);
      this.getInfo();
      this.agreementShow = false;
    },
    showLoginMessage() {
      this.$message({
        showClose: true,
        type: 'error',
        duration: 5000,
        message: '您当前登录的账号未注册开放平台，如需使用请用已注册账号登录。',
      });
    },
    goHome() {
      if (this.routeName === 'home') return;
      this.$router.push('home');
    },
    goLogin() {
      this.$router.replace('login');
    },
    goRegister() {
      this.$router.push('Register');
    },
    goDoc() {
      window.open('https://openapi.aiclk.com/docs/');
    },
    handleSelect(key, keyPath) {
      if (this.routeName === key) return;
      this.$router.push(key);
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.company = '';
        this.doLogout(this.goLogin);
      }
    },
  },
};
</script>

<style lang="scss">
.mod-layout {
  .layout-header {
    .el-menu.el-menu--horizontal {
      border-bottom: none;
      .el-menu-item {
        font-size: 18px;
        font-weight: 400;
        &:hover {
          font-size: 18px;
          font-weight: 700;
        }
        &.is-active {
          font-size: 18px;
          font-weight: 700;
        }
      }
    }
  }
  .agreement-dialog {
    .el-dialog--center .el-dialog__body {
      padding: 0 25px;
    }
  }
}
</style>

<style lang="scss" scoped>
.mod-layout {
  min-width: $standard-width;
  height: 100%;
  .btn-link-box {
    .btn-link {
      font-size: 18px;
      font-family: Noto Sans S Chinese;
      color: #909399;
      cursor: pointer;
      z-index: 10;
      &:hover {
        color: $primary-color;
      }
    }
  }
  .layout-header {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    height: 80px;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #e6e6e6;
    }
    .logo {
      flex-shrink: 0;
      padding-left: 44px;
      padding-right: 62px;
      font-size: 25px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: rgba(48, 49, 51, 1);
      background-image: url('~@/assets/image/logo_color.svg');
      background-size: 32px;
      background-repeat: no-repeat;
      background-position: 0;
    }
    .menus-box {
      flex-grow: 1;
      overflow-y: hidden;
      overflow: auto;
    }
    .icon-separator-vertical {
      display: inline-block;
      width: 1px;
      height: 18px;
      margin: 0 30px;
      background: #979797;
    }
    .profile {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(144, 147, 153, 1);
    }
  }
  .content-main {
    height: calc(100% - 80px);
    display: flex;
    justify-content: center;
    padding: 0;
    .content-view {
      width: 100%;
      max-width: $standard-width;
      &.login {
        max-width: 100%;
      }
    }
  }
  &.page-home,
  &.page-register {
    width: 100%;
    position: relative;
    overflow: auto;
    &:after {
      content: ' ';
      position: absolute;
      top: -90px;
      right: 0;
      width: 100%;
      height: 786px;
      box-sizing: border-box;
      background-image: linear-gradient(180deg, #034bbf, $primary-color);
      transform: skewY(-5deg);
      z-index: -1;
    }
    .layout-header {
      color: #fff !important;
      &:after {
        background: rgba(0, 0, 0, 0);
      }
      .logo {
        background-image: url('~@/assets/image/logo.svg');
        color: #fff;
      }
      .menus-box {
        .el-menu.el-menu--horizontal {
          background-color: rgba(0, 0, 0, 0);
          .el-menu-item {
            color: #fff;
            &:hover {
              background-color: rgba(0, 0, 0, 0) !important;
              font-weight: bolder;
            }
            &.is-active {
              color: #fff !important;
              font-weight: bolder;
              border-bottom: none !important;
              background-color: rgba(0, 0, 0, 0) !important;
            }
          }
        }
      }
      .profile {
        color: #fff;
      }
    }
    .btn-link-box {
      position: relative;
      &:hover {
        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 8px;
          margin-top: -8px;
          background-color: #3f90f7;
          border-radius: 999px;
          z-index: 1;
        }
      }
      .btn-link {
        font-size: 18px;
        font-family: Noto Sans S Chinese;
        color: #fff;
        cursor: pointer;
        z-index: 10;
        &:hover {
          font-weight: bold;
          color: #fff;
        }
      }
    }
    .icon-separator-vertical {
      background: #fff;
    }
    .content-main {
      position: relative;
      height: fit-content;
      overflow: unset;
    }
  }
  &.page-home {
    .content-main {
      position: relative;
      height: fit-content;
      overflow: unset;
      &:after {
        content: ' ';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 460px;
        background-image: linear-gradient(to right, #034bbf, $primary-color);
        z-index: -1;
      }
    }
  }
  .agreement-box {
    height: 500px;
    margin: 0px;
    overflow: scroll;
    white-space: break-spaces;
  }
}
</style>
